import { fromJS } from 'immutable';
import { TrumpismDTO } from 'services/dto/trumpism';

// ACTIONS
import {
  FETCH_TRUMPISMS_ERROR,
  FETCH_TRUMPISMS_SUCCESS,
  GET_TRUMPISM_ERROR,
  GET_TRUMPISM_SUCCESS,
  REQUEST_FETCH_TRUMPISMS,
  REQUEST_GET_TRUMPISM
} from 'actions/types';

const INITIAL_STATE = fromJS({
  all: [],
  error: null,
  fetched: false,
  loading: false
});

// SELECTORS

// REDUCER
export default function trumpisms(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_FETCH_TRUMPISMS:
      return state.merge({
        all: [],
        error: null,
        fetched: false,
        loading: true
      });
    case FETCH_TRUMPISMS_SUCCESS:
      const all = action.data.items.map(item => new TrumpismDTO(item));
      return state.merge({ all, error: null, fetched: true, loading: false });
    case FETCH_TRUMPISMS_ERROR:
      return state.merge({
        all: [],
        error: action.err,
        fetched: true,
        loading: false
      });
    case REQUEST_GET_TRUMPISM:
      return state.merge({ error: null, fetched: false, loading: true });
    case GET_TRUMPISM_SUCCESS:
      const idx = state
        .get('all')
        .findIndex(val => val.get('id') === action.data.id);
      if (idx >= 0) {
        return state
          .setIn(['all', idx], new TrumpismDTO(action.data))
          .merge({ fetched: true });
      } else {
        return state.merge({
          all: state.get('all').push(new TrumpismDTO(action.data)),
          error: null,
          fetched: true,
          loading: false
        });
      }
    case GET_TRUMPISM_ERROR:
      return state.merge({ error: action.err, fetched: true, loading: false });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/trumpisms.js